import React, { useEffect, useState } from "react";
import capitalize from "lodash/capitalize";
import find from "lodash/find";
import Apps from "../../../config/Apps";

const InfoModal = ({ appInfo }) => {
  const [app, setApp] = useState("");
  useEffect(() => {
    setApp(find(Apps, { name: appInfo }));
  }, [appInfo]);

  return (
    <div
      className="modal fade"
      id="modal-api-info"
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div>
            <h4 className="text-center mb-4">{capitalize(app.name)}</h4>
            <p>{app.info}</p>

            <div className="text-center">
              <button
                type="button"
                className="btn btn-main"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

InfoModal.propTypes = {};

export default InfoModal;
